/**
 * 
 * @param {*} str String to be logged.
 * @param {*} color Color of log msg
 * @param {*} data Data to log
 */
 export default function (str,color="white",data="") {
    if (window.dsactivatelogger) {
        console.log('%c%s', `color:${color}`, str,data);
    }
}